export default __webpack_public_path__ + "5babd1cb6921c78834a23f55145f73b1.png";